import * as React from 'react';
import {ITextProps} from './ITextProps';
import {Base} from './Base';

export const Tt2b = (props: ITextProps) => {
  return <Base typoClass="typo2b" {...props} />;
};
